<ion-toolbar>
  <ion-buttons slot="start">
    <ion-button fill="outline" type="button" color="secondary" (click)="close()">
      <ion-icon name="arrow-back"></ion-icon>
      <span class="hidden-md">&nbsp; {{ 'ACTION.back' | translate }}</span>
    </ion-button>
  </ion-buttons>
  <ion-title data-testid="title" role="heading" aria-level="2">{{ 'TITLE.groupStop' | translate }}</ion-title>
</ion-toolbar>


<ion-content class="ion-padding">

  <ul data-testid="routeEventList" #list>
    @for (data of routeEvents; track data) {
      @if (!data.completed && !data.value.performTime) {
        <li
          class="route-event {{ data.type }}"
          [ngClass]="{ 'started': data.started }" data-testid="routeEvent"
          >
          <div class="icons type">
            @for (icon of data.typeIcons; track icon) {
              @if (icon.svg) {
                <ion-icon
                  [class]="icon.type"
                  [src]="'assets/icons/' + icon.name + '.svg'"
                  [title]="icon.label | translate"
                  [data-testid]="icon.label"
                  />
              }
              @if (!icon.svg) {
                <ion-icon
                  [class]="icon.type"
                  [name]="icon.name"
                  [title]="icon.label | translate"
                  [data-testid]="icon.label"
                  />
              }
            }
          </div>
          <div class="header">
            <span data-testid="type" class="title" [attr.aria-level]="headerLevel">{{ data.headerInfo.type | translate }}</span>
            @if (data.headerInfo.details) {
              <span data-testid="details" class="details">{{ data.headerInfo.details }}</span>
            }
            @if (data.headerInfo.subtitle) {
              <div data-testid="subtitle" class="subtitle">{{ data.headerInfo.subtitle }}</div>
            }
          </div>
          <div class="actions">
            @if (data.tapForDetails) {
              <ion-button
                type="button"
                expand="block"
                color="medium"
                fill="outline"
                (click)="data.tapForDetails()"
                data-testid="tapForDetails"
                [attr.aria-label]="'LABEL.tapForDetails' | translate"
                size="small"
                >
                <ion-icon name="expand" slot="icon-only" aria-hidden="true" />
              </ion-button>
            }
            @for (action of data.actions; track action) {
              @if (action.type === 'perform') {
                <ion-button
                  type="button"
                  expand="block"
                  [color]="action.color"
                  [fill]="action.fill"
                  (click)="action.fn(action)"
                  [disabled]="action.disabled"
                  [data-testid]="action.label"
                  [attr.aria-label]="action.label | translate"
                  [data-testid]="action.label"
                  size="small"
                  >
                  <ion-icon slot="icon-only" [name]="action.icon" aria-hidden="true"/>
                </ion-button>
              }
            }
          </div>
        </li>
      }
    }
  </ul>

</ion-content>

<ion-toolbar class="bottom-actions">
  <ion-button type="button" fill="outline" expand="block" (click)="close()">{{ 'ACTION.close' | translate }}</ion-button>
</ion-toolbar>
